"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pakt = exports.nobel = exports.default = exports.decimaMonoPro = exports.akkuratMono = void 0;
var _typography = _interopRequireDefault(require("../../packages/typography"));
var _lexus = _interopRequireDefault(require("./lexus.typography"));
const {
  nobel,
  pakt,
  decimaMonoPro,
  akkuratMono
} = (0, _typography.default)(_lexus.default);
exports.akkuratMono = akkuratMono;
exports.decimaMonoPro = decimaMonoPro;
exports.pakt = pakt;
exports.nobel = nobel;
var _default = exports.default = {
  nobel,
  pakt,
  decimaMonoPro,
  akkuratMono
};